import { usePartnerFetchRepairEstimateApi } from 'api/partner/repair_estimate';
import { GlobalStateContext } from 'contexts/global_state_context';
import React, { useContext, useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { PartnerRouteHelper } from 'routes/partner';
import { useEffectSkipFirst } from 'utils/hooks';

export const RepairEstimateShow: React.FC = () => {
  const globalState = useContext(GlobalStateContext);
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const estimateApi = usePartnerFetchRepairEstimateApi(Number(id));

  useEffect(() => {
    estimateApi.execute();
  }, []);
  useEffectSkipFirst(() => {
    globalState.setLoading(estimateApi.loading);
    if (estimateApi.isSuccess() && estimateApi.response.repairEstimate.repairInfoId) {
      navigate(PartnerRouteHelper.repairInfoShow(estimateApi.response.repairEstimate.repairInfoId));
    }
  }, [estimateApi.loading]);

  return <></>;
};

export default RepairEstimateShow;
